import { DocumentReuseStatus } from "../types/Inspection";
import api from "../config/api";
import handleResponse from "./ResponseHandler";
import {ReUseAsset} from "../types/ReUseAsset";
import { DefectItem } from "../types/DefectItem";
import { DefectImage } from "../types/DefectImage";

export const updateInspectionDocumentReuseStatus = (
    inspectionId: string,
    reuseStatus: DocumentReuseStatus,
    idToken: string,
    reUseAssets : ReUseAsset[]
    ) => {
    return new Promise(function (resolve, reject) {
        const body = {
            inspectionId: inspectionId,
            docReuse: reuseStatus,
            reUseAssets : reUseAssets
        }

        const options = {
            method: "POST",
            headers: {
                "Accept": "application/json, text/plain, */*",
                "idtoken": idToken,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body)
        };

        fetch(api.updateInspectionReuseStatus, options)
            .then((reponse) => handleResponse(reponse))
            .then((response) => response.json())
            .then((data) => {
                resolve(data);
            })
            .catch((response) => {
                reject({
                    status: response.statusText,
                    statusCode: response.statusCode
            })
        });
    });
}

export const updateInspectionReportReuseStatus = (
    inspectionId: string,
    reportElementId: string,
    reuseReport: boolean,
    idToken: string
    ) => {
    return new Promise(function (resolve, reject) {
        const body = {
            inspectionId: inspectionId,
            inspectionReportId: reportElementId,
            docReuse: reuseReport ?? false
        }

        const options = {
            method: "POST",
            headers: {
                "Accept": "application/json, text/plain, */*",
                "idtoken": idToken,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body)
        };

        fetch(api.updateInspectionReportReuseStatus, options)
            .then((reponse) => handleResponse(reponse))
            .then((response) => response.json())
            .then((data) => {
                resolve(data);
            })
            .catch((response) => {
                reject({
                    status: response.statusText,
                    statusCode: response.statusCode
            })
        });
    });
}

export const assignImagesToDefect = (
    inspectionId: string,
    defect: DefectItem,
    selectedImages: DefectImage[],
    defectElementId: string,
    idToken: string,
    ) => {
    return new Promise(function (resolve, reject) {
        const body = {
            inspectionId: inspectionId,
            defectItem: defect,
            selectedImageIds: selectedImages.map(img => img.Id),
            defectElementId: defectElementId
        }

        const options = {
            method: "POST",
            headers: {
                "Accept": "application/json, text/plain, */*",
                "idtoken": idToken,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body)
        };

        fetch(api.assignImagesToDefect, options)
            .then((reponse) => handleResponse(reponse))
            .then((response) => response.json())
            .then((data) => {
                resolve(data);
            })
            .catch((response) => {
                reject({
                    status: response.statusText,
                    statusCode: response.statusCode
            })
        });
    });
}